"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatInfoMobile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const ChatHeader_1 = require("./ChatHeader");
const resources_1 = require("../../resources");
const typography_1 = require("../../shared/typography");
const ChatInfoMobile = ({ onBackLinkClick, onAppStoreClick, onGooglePlayClick }) => {
    const { t } = (0, react_i18next_1.useTranslation)("md");
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(ChatHeader_1.ChatHeader, { receiver: { name: "Chat in PBP app", photo: (0, jsx_runtime_1.jsx)(resources_1.LogoCL_Small, {}, void 0) }, onLinkClick: onBackLinkClick, linkTranslation: t("chatView.goBackLink") }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("chatView.chatMobileInfo") }, void 0), (0, jsx_runtime_1.jsxs)(StoresWrapper, { children: [(0, jsx_runtime_1.jsx)("div", { onClick: onAppStoreClick, children: (0, jsx_runtime_1.jsx)(resources_1.IOSStore, {}, void 0) }, void 0), (0, jsx_runtime_1.jsx)("div", { onClick: onGooglePlayClick, children: (0, jsx_runtime_1.jsx)(resources_1.GoogleStore, {}, void 0) }, void 0)] }, void 0)] }, void 0)] }, void 0));
};
exports.ChatInfoMobile = ChatInfoMobile;
const Wrapper = styled_components_1.default.div `
  & > div:first-of-type {
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    border-top: 1px solid ${({ theme }) => theme.colors.silverBase};

    padding: 0;

    & img {
      border-radius: 0;
    }
  }

  & > div:last-of-type {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

    & p {
      color: ${({ theme }) => theme.colors.greyBase};
      white-space: pre-line;
    }
  }
`;
const StoresWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacings.xs};
  width: 100%;

  & > div {
    flex: 1;
  }

  & > div:last-of-type {
    align-items: flex-start;
    display: flex;
    justify-content: flex-end;
  }

  img {
    cursor: pointer;
    width: 100%;
    max-width: 20rem;
  }

  div:first-of-type {
    margin-right: ${({ theme }) => theme.spacings.m};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.phoneMini}) {
    flex-direction: column;
    align-items: center;

    & > div {
      width: 100%;
    }

    div:first-of-type {
      margin-bottom: ${({ theme }) => theme.spacings.m};
      margin-right: 0;
    }
  }
`;
//# sourceMappingURL=ChatInfoMobile.js.map